import type { ApiError } from '@/api/client';

/**
 * Whether an error is the server refusing a save because the record changed since it was read.
 *
 * Every non-2xx answer from the API client is an `ApiError` carrying the HTTP status, and a 409
 * is how the server says "someone else saved first". The check reads the status rather than the
 * class so that the module-specific subclasses (`CustomerApiError`, `SettingsRequestError`,
 * `FieldConflictError`) all count, without this library depending on any of them.
 *
 * @param error whatever a failed request threw
 * @returns true for a version conflict
 */
export function isConflictError(error: unknown): error is ApiError {
  return error instanceof Error && 'status' in error && error.status === 409;
}
